
// import React, { useState, useEffect } from "react";
// import "./Customer.css";
// import HeaderTitle from "../HederTitle/HeaderTitle";
// import axios from "axios";
// import { backend_url } from "../../App";

// const Customer = () => {
//   const [currentIndex, setCurrentIndex] = useState(0);
//   const [reviews, setReviews] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);

//   useEffect(() => {
//     const fetchReviews = async () => {
//       try {
//         const response = await axios.get(`${backend_url}/api/customerreview`);
//         const filteredReviews = response.data.filter(review => review.showReview === true);
//         setReviews(filteredReviews);
//         setLoading(false);
//       } catch (err) {
//         setError("Failed to fetch reviews");
//         setLoading(false);
//         console.error("Error fetching reviews:", err);
//       }
//     };

//     fetchReviews();
//   }, []);

//   const handlePrev = () => {
//     setCurrentIndex((prevIndex) =>
//       prevIndex === 0 ? reviews.length - 1 : prevIndex - 1
//     );
//   };

//   const handleNext = () => {
//     setCurrentIndex((prevIndex) =>
//       prevIndex === reviews.length - 1 ? 0 : prevIndex + 1
//     );
//   };

//   if (loading) return <div className="loading">Loading testimonials...</div>;
//   if (error) return <div className="error">{error}</div>;
//   if (reviews.length === 0) return <div className="no-reviews">No testimonials available</div>;

//   const currentReview = reviews[currentIndex];

//   return (
//     <>
//       <HeaderTitle Header="What Customer's Say About Us" />
//       <div className="customer-container">
//         <div className="testimonial-card">
//           {currentReview.reviewImage && (
//             <img crossOrigin="anonymous"  
//               src={currentReview.reviewImage} 
//               alt={currentReview.name} 
//               className="customer-image" 
//               onError={(e) => {
//                 e.target.src = "https://via.placeholder.com/150?text=Customer";
//               }}
//             />
//           )}
//           <div className="testimonial-content">
//             <div className="rating">
//               {[...Array(5)].map((_, i) => (
//                 <span 
//                   key={i} 
//                   className={`star ${i < parseInt(currentReview.rating || 0) ? 'filled' : ''}`}
//                 >
//                   ★
//                 </span>
//               ))}
//             </div>
//             <h3 className="customer-name">{currentReview.name}</h3>
//             {currentReview.reviewTitle && (
//               <h4 className="review-title">{currentReview.reviewTitle}</h4>
//             )}
//             <p className="customer-review">"{currentReview.review}"</p>
//           </div>
//         </div>

//         {reviews.length > 1 && (
//           <div className="nav-buttons-wrapper">
//             <button className="nav-button left" onClick={handlePrev}>
//               &lt;
//             </button>
//             <span className="review-counter">
//               {currentIndex + 1} / {reviews.length}
//             </span>
//             <button className="nav-button right" onClick={handleNext}>
//               &gt;
//             </button>
//           </div>
//         )}
//       </div>
//     </>
//   );
// };

// export default Customer;

import logo from "../Assets/fab hub logo (tm).png";

import React, { useState, useEffect } from "react";
import "./Customer.css";
import HeaderTitle from "../HederTitle/HeaderTitle";
import axios from "axios";
import { backend_url } from "../../App";

const Customer = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [reviews, setReviews] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fallbackImage = logo ;

  useEffect(() => {
    const fetchReviews = async () => {
      try {
        const response = await axios.get(`${backend_url}/api/customerreview`);
        const filteredReviews = response.data.filter(review => review.showReview === true);
        setReviews(filteredReviews);
        setLoading(false);
      } catch (err) {
        setError("Failed to fetch reviews");
        setLoading(false);
        console.error("Error fetching reviews:", err);
      }
    };

    fetchReviews();
  }, []);

  const handlePrev = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex === 0 ? reviews.length - 1 : prevIndex - 1
    );
  };

  const handleNext = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex === reviews.length - 1 ? 0 : prevIndex + 1
    );
  };

  if (loading) return <div className="loading">Loading testimonials...</div>;
  if (error) return <div className="error">{error}</div>;
  if (reviews.length === 0) return <div className="no-reviews">No testimonials available</div>;

  const currentReview = reviews[currentIndex];

  // Construct full image URL if stored as filename
  const getImageURL = () => {
    if (currentReview.reviewImage?.trim()) {
      // If it's already a full URL
      if (currentReview.reviewImage.startsWith("http")) {
        return currentReview.reviewImage;
      }
      // Else assume it's a filename stored on server
      return `${backend_url}/uploads/${currentReview.reviewImage}`;
    }
    return fallbackImage;
  };

  return (
    <>
      <HeaderTitle Header="What Customer's Say About Us" />
      <div className="customer-container">
        <div className="testimonial-card">
          <img crossOrigin="anonymous" 
            src={getImageURL()}
            alt={currentReview.name}
            className="customer-image"
            onError={(e) => {
              e.target.src = fallbackImage;
            }}
          />

          <div className="testimonial-content">
            <div className="rating">
              {[...Array(5)].map((_, i) => (
                <span
                  key={i}
                  className={`star ${i < parseInt(currentReview.rating || 0) ? 'filled' : ''}`}
                >
                  ★
                </span>
              ))}
            </div>

            <h3 className=" first-letter:uppercase customer-name">{currentReview.name.charAt(0).toUpperCase() +   currentReview.name.slice(1)}</h3>

            {currentReview.reviewTitle && (
              <h4 className="first-letter:uppercase review-title">{currentReview.reviewTitle.charAt(0).toUpperCase() +   currentReview.reviewTitle.slice(1)}</h4>
            )}

            <p className="first-letter:uppercase customer-review ">"{currentReview.review.charAt(0).toUpperCase() + currentReview.review.slice(1)}"</p>
             
          </div>
        </div>

        {reviews.length > 1 && (
          <div className="nav-buttons-wrapper">
            <button className="nav-button left" onClick={handlePrev}>
              &lt;
            </button>
            <span className="review-counter">
              {currentIndex + 1} / {reviews.length}
            </span>
            <button className="nav-button right" onClick={handleNext}>
              &gt;
            </button>
          </div>
        )}
      </div>
    </>
  );
};

export default Customer;
